import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Tag } from 'rsuite';
import { LimitRulesItemType } from '../../../interfaces/reservation';

const Rules = styled.div`
  padding: 5px;
  font-weight: bold;
  border-radius: 5px;
  display: inline-block;
  border: 1px solid #ddd;
  > .rs-tag {
    border: 1px solid #aaa;
    + .rs-tag {
      margin-left: 5px;
    }
  }
`;

function LimitRulesLabel({ rules, size, ...props }) {
  return (
    <Rules {...props}>
      {rules.map(({ key, quantity }) => (
        <Tag key={key} style={{ fontSize: size }}>
          {key}: {quantity}
        </Tag>
      ))}
    </Rules>
  );
}

LimitRulesLabel.propTypes = {
  rules: PropTypes.arrayOf(LimitRulesItemType).isRequired,
  size: PropTypes.number
};

LimitRulesLabel.defaultProps = {
  size: 12
};

export default LimitRulesLabel;
